{
  "version": 1,
  "asset_id": "e4398493-21cb-405d-bab1-78b6db9eef4b",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e4398493-21cb-405d-bab1-78b6db9eef4b/mark-128.png",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e4398493-21cb-405d-bab1-78b6db9eef4b/mark-128.png",
  "original_filename": "mark-128.png",
  "size": 8967,
  "content_type": "image/png",
  "created_at": "2026-07-25T02:18:08Z"
}
